"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.n = (module)=>{
        var getter = module && module.__esModule ? ()=>module['default'] : ()=>module;
        __webpack_require__.d(getter, {
            a: getter
        });
        return getter;
    };
})();
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    CustomMarkdown: ()=>CustomMarkdown
});
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
require("react");
const external_pcln_design_system_namespaceObject = require("pcln-design-system");
const external_react_markdown_namespaceObject = require("react-markdown");
var external_react_markdown_default = /*#__PURE__*/ __webpack_require__.n(external_react_markdown_namespaceObject);
const external_CustomLink_js_namespaceObject = require("./CustomLink.js");
const Header = (props)=>/*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Text, {
        textStyle: "heading5",
        my: 1,
        children: props.children
    });
const BoldText = (props)=>/*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Text.span, {
        textStyle: "paragraph2Bold",
        children: props.children
    });
const Paragraph = (props)=>/*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Text, {
        fontSize: 2,
        children: props.children
    });
const ItalicText = (props)=>/*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Text, {
        fontStyle: "italic",
        children: props.children
    });
const ImageComponent = ({ src, alt })=>/*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Image, {
        src: src,
        alt: alt,
        style: {
            display: 'inline-block',
            marginRight: '8px'
        },
        borderRadius: "xl",
        width: "120px",
        height: "90px"
    });
const List = (props)=>/*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("ul", {
        style: {
            listStyleType: 'disc',
            marginLeft: '24px'
        },
        children: props.children
    });
const ListItem = (props)=>/*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("li", {
        style: {
            marginBottom: '4px',
            marginTop: '4px'
        },
        children: props.children
    });
const HorizontalRule = ()=>/*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Box, {
        mb: 1,
        children: "---"
    });
const CustomMarkdown = (props)=>/*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_react_markdown_default(), {
        components: {
            a: external_CustomLink_js_namespaceObject.CustomLink,
            b: BoldText,
            strong: BoldText,
            p: Paragraph,
            em: ItalicText,
            header: Header,
            h1: Header,
            h2: Header,
            h3: Header,
            h4: Header,
            h5: Header,
            h6: Header,
            img: ImageComponent,
            hr: HorizontalRule,
            br: HorizontalRule,
            ul: List,
            li: ListItem
        },
        children: props.children
    });
exports.CustomMarkdown = __webpack_exports__.CustomMarkdown;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "CustomMarkdown"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
